// 'use client'

import DatoLink from '@/components/DatoLink/DatoLink'
import { cn, getGridCols } from '@desoutter/uikit'
import { Button } from '@desoutter/uikit/src/components/atoms/Button'
import Image from 'next/image'
import { Image as DatoImage } from 'react-datocms'
import { DatoLinkFragment } from '@/components/DatoLink/DatoLink.generated'
import { DropdownCardBlockFragment } from './DropdownCardBlock.generated'
import { MenuCardsMinimal } from '../MenuCards/MenuCardsMinimal'
import { MenuCardsFull } from '../MenuCards/MenuCardsFull'

export function DropdownCardMenuContent({
	dropdownCarMenu,
	colsNumber,
	showIcon,
	className,
	closeMenu,
}: {
	dropdownCarMenu: DropdownCardBlockFragment
	colsNumber?: number
	showIcon?: boolean
	className?: string
	closeMenu?: () => void
}) {
	return (
		<div className={cn('flex flex-col', className)}>
			{dropdownCarMenu.image?.responsiveImage?.src && (
				<div key={dropdownCarMenu.titleLink?.label} onClick={closeMenu}>
					<DatoLink
						fragment={dropdownCarMenu.titleLink as DatoLinkFragment}
						className="group pb-1"
					>
						<div className="flex justify-between items-center mt-5 lg:mt-0 mb-4 rounded-lg overflow-hidden">
							{dropdownCarMenu.image?.responsiveImage && (
								<DatoImage
									data={dropdownCarMenu.image?.responsiveImage}
									layout="responsive"
									objectFit="cover"
									className="h-32 lg:h-52 xl:h-64 2xl:h-72 group-hover:scale-110 duration-150 ease-out"
								/>
							)}
						</div>
						<div className="flex items-center">
							{!!dropdownCarMenu.titleLink?.icon && showIcon ? (
								<Image
									placeholder="empty"
									width={20}
									height={20}
									className="mr-3 lg:invert dark:lg:invert-0 w-auto h-auto"
									alt={dropdownCarMenu.titleLink?.label || 'Menu icon'}
									src={
										dropdownCarMenu.titleLink?.icon.url ||
										'/images/image-placeholder.svg'
									}
								/>
							) : null}
							<span>{dropdownCarMenu.titleLink?.label}</span>
						</div>
						{dropdownCarMenu.description && (
							<p className="hidden lg:block mt-3 text-xs dark:text-gray-300 text-gray-500">
								{dropdownCarMenu.description}
							</p>
						)}
					</DatoLink>
				</div>
			)}
			{!dropdownCarMenu.image?.responsiveImage?.src &&
				!!dropdownCarMenu.cardLinks?.length && (
					<>
						<div onClick={closeMenu} className="min-h-14">
							<DatoLink
								key={dropdownCarMenu.titleLink?.label}
								fragment={dropdownCarMenu.titleLink as DatoLinkFragment}
								className="group/link flex justify-between mb-2"
							>
								<div className="mb-2 mt-0 overflow-visible text-lg font-normal">
									{dropdownCarMenu.title}
								</div>
								<div>
									<Button
										variant="outline"
										color="adaptive"
										size="sm"
										className="!border-gray-600 group-hover/link:!border-gray-900 group-hover/link:dark:!border-white"
										title="arrow"
									/>
								</div>
							</DatoLink>
							{dropdownCarMenu.description && (
								<p className="pb-6 text-xs text-gray-500 dark:text-gray-300 stroke-gray-900 dark:stroke-white">
									{dropdownCarMenu.description}
								</p>
							)}
						</div>
						<div
							className={cn(
								'pt-4 pb-1 border-0 border-t border-gray-600 lg:grid grid-flow-row gap-1',
								colsNumber < 2
									? `${getGridCols(dropdownCarMenu.cardLinks.length)} gap-2`
									: 'grid-cols-1',
							)}
						>
							{dropdownCarMenu.cardLinks.map((card) =>
								dropdownCarMenu.showCardDescription ? (
									<MenuCardsFull
										key={card.id}
										card={card}
										isVertical={colsNumber < 2}
									/>
								) : (
									<MenuCardsMinimal key={card.id} card={card} />
								),
							)}
						</div>
					</>
				)}
		</div>
	)
}
